// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__35MGN","checkboxCol":"Table_checkboxCol__228LI","emailCol":"Table_emailCol__Y7E8p","actionCol":"Table_actionCol__1Qold"};